export default {
  DAILYBREAK: 'DAILYBREAK_STEP',
  DEMO: 'DEMO_STEP',
  EMBED: 'EMBED_STEP'
};



// WEBPACK FOOTER //
// ./public/pages/ViewAllPlatforms/SortableStepTypes.js